import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { UpdateAdminArtistResponse } from './types';

export async function updateAdminArtist(artistId: string, params: { destroyed: boolean }) {
  const url = `/web/studio/admin/artists/${artistId}`;

  const body = { destroyed: params.destroyed };

  const response = await api.executePutRequest<ObjectResponse<UpdateAdminArtistResponse>>(url, body);

  return response.data;
}
